export default __webpack_public_path__ + "static/media/mysql.72bab5fa.svg";